/** Shared live-update timings for the admin portal (React Query). */

export const LIVE_STALE_MS = 4_000;
export const LIVE_GC_MS = 10 * 60_000;

export const LIVE_POLL = {
  CHAT: 3_000,
  LIST: 8_000,
  BADGE: 10_000,
  STATS: 15_000,
  SETTINGS: 60_000,
  NOTIFICATIONS: 20_000,
  NOTIFICATIONS_SUMMARY: 12_000,
} as const;

export function livePollInterval(ms: number): number | false {
  if (typeof document !== 'undefined' && document.hidden) {
    return false;
  }
  return ms;
}
